import { render } from "./App.vue?vue&type=template&id=b587cbba"
const script = {}

import exportComponent from "D:\\project\\my_personal_website\\web\\router_demo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__